module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/img_main-e1b0dc96cf7715435f9eb7a92a314f62.svg";